import cx from 'classnames';
import styles from 'partials/loading.module.scss'

export const LoadingMask = ({ className }) => {
	const maskClass = cx(styles.loading, className);

	return <div className={maskClass}></div>;
};